import { ReactNode, createContext, useContext, useEffect, useState } from "react";
import { getAxiosInstance } from "./axiosInstance";
import { AppUser } from "./types.global";

interface UserContextInterface {
    user: AppUser| null
    setUser: (user: AppUser| null) => void
    permission: string[]
    setPermission: (data: string[]) => void
    reloadData: () => void
}

// @ts-ignore
export const UserContext: React.Context<UserContextInterface> = createContext({
    user: null,
    setUser: (data) => { },
    permission: [],
    setPermission: (data) => { },
    reloadData: () => { }
});

export const useUserContext = () => useContext(UserContext);

export const UserProvider = (props: { children: ReactNode }) => {
    const [user, setUser] = useState<AppUser| null>(null);
    const [permission, setPermission] = useState<string[]>([]);

    const getAccount = async() => {
        try {
            const req = await getAxiosInstance().get('/account');
            setUser(req.data);

            if(["/login", "/"].indexOf(window.location.pathname) !== -1)
                window.location.replace('/dashboard');

        } catch (e) {
            // @TODO: add a refresh token
            console.error("The token is not valid. Can't fetch the user account data.");
            localStorage.removeItem("token");
            if(window.location.pathname !== "/login") {
                window.location.replace('/login');
            }
        }
    } 

    const getPermission = async () => {
        try {
            const res = await getAxiosInstance().get("/Users/permissions")
            setPermission(res.data);
        } catch (e) {
            console.error("Can't get the user permission list!")
        }
    }

    useEffect(() => {
        if(!user) {
            const token = localStorage.getItem('token');
            if (!token && window.location.pathname !== "/login") {
                window.location.replace('/login');
            } else if (token) {
                getAccount();
                getPermission();
            }
        }
    }, [user]);

    return (
        <UserContext.Provider value={
            {
                user,
                setUser: (data) => setUser(data),
                permission: permission,
                setPermission: (data) => setPermission(data),
                reloadData: () => {
                    getAccount().then(() => getPermission())
                }
            }
        }>
            {( user || window.location.pathname === "/login" ) && props.children}
        </UserContext.Provider>
    )

}